<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div *ngIf="
      customFields && customFields.length > 0;
      else nocustomFields
    ">
    <p-panel>
      <p-header>
        <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing' |
          translate }} {{ customFields ? customFields.length : '0' }} logs </span>
      </p-header>
      <p-table [value]="customFields" sortField="name" sortOrder="1" [scrollable]="false" [resizableColumns]="true"
        class="footer-over-pagination" [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'name'"> Nombre </th>
            <th [pSortableColumn]="'type'" class="TEXT"> Tipo </th>
            <th class="TEXT"> {{ 'Recurso' | translate}} </th>
            <th class="TEXT"> {{ 'CustomField.DestinationGroup' | translate}} </th>
            <th class="action-column"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customField>
          <tr>
            <td field="name"> {{customField.name}} <div>
                <span><small>{{customField.display.i18nDescription}}</small></span>
              </div>
            </td>
            <td field="type" class="TEXT"> {{customField.type}} </td>
            <td field="name" class="TEXT"> {{customField.owner.resource.description}} </td>
            <td field="name" class="TEXT"> {{ getDestination(customField) }} </td>
            <td>
              <button class="btn btn-xs btn-default" aria-expanded="false"
                (click)="startCustomFieldEdition(customField)" type="button">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</div>
<ng-template #nocustomFields>
  <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted" role="alert">
    <span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'CustomField.nocustomFields' |
      translate }}</span>
  </div>
</ng-template>